const CustomLabelIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M7.97335 2.5H4.375C3.33947 2.5 2.5 3.33947 2.5 4.375V7.97335C2.5 8.47063 2.69754 8.94754 3.04917 9.29917L11.0334 17.2834C11.6157 17.8657 12.5166 18.0098 13.2054 17.5587C14.9392 16.4237 16.4237 14.9392 17.5587 13.2054C18.0098 12.5166 17.8657 11.6157 17.2834 11.0334L9.29917 3.04917C8.94754 2.69754 8.47063 2.5 7.97335 2.5Z"
        stroke="#A88CA4"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5H5.00625V5.00625H5V5Z"
        stroke="#A88CA4"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CustomLabelIcon
